import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { RentalReservationRecordCategoryEnum } from '../enums/rental-reservation-record-category.enum';
import { RentalReservationStatusEnum } from '../enums/rental-reservation-status.enum';

/**
 * Rental reservation list DTO
 */
@CaslSubject(AppSubjectEnum.RENTAL_RESERVATION)
export class RentalReservationListDto extends BaseDto {
  code!: string;
  recordCategory!: RentalReservationRecordCategoryEnum;
  startsAt!: Date;
  endsAt!: Date;
  vehicleId?: number | null;
  vehicleCategoryId?: number | null;
  pickupLocationId?: number | null;
  dropOffLocationId?: number | null;
  agentId?: number | null;
  computedTotalGross?: number | null;
  status!: RentalReservationStatusEnum;
}
